import { computed, type Ref } from 'vue'
import {
  buildDoorOpenEchartsStateTimelineOption,
  type DoorOpenPeriodInput,
} from '@/utils/components/door-open-chart'

export function useSensorDoorOpenChart(
  rowLabel: Ref<string>,
  openPeriodsMs: Ref<[number, number][]>,
  rangeStartMs: Ref<number | null>,
  rangeEndMs: Ref<number | null>,
  alarmPeriodsMs: Ref<[number, number][]>,
  hoveredAlarmIndex: Ref<number | null>,
  savedDataZoom: Ref<{ start: number; end: number }>,
) {
  const chartOptions = computed(() => {
    const start = rangeStartMs.value
    const end = rangeEndMs.value
    if (start == null || end == null || end <= start) {
      return {}
    }

    const openPeriods: DoorOpenPeriodInput[] = openPeriodsMs.value.map(([periodStart, periodEnd]) => ({
      y: [periodStart, periodEnd],
    }))

    return buildDoorOpenEchartsStateTimelineOption({
      rowLabel: rowLabel.value || 'Status',
      openPeriods,
      rangeStart: start,
      rangeEnd: end,
      alarmPeriods: alarmPeriodsMs.value,
      hoveredAlarmIndex: hoveredAlarmIndex.value,
      dataZoom: savedDataZoom.value,
    })
  })

  return { chartOptions }
}
